module.exports = __webpack_public_path__ + "static/img/3.5deaffc.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/channel/dingtalk/3.png
// module id = JmcJ
// module chunks = 1